// translations.js
const translations = {
      title: "קד\"מ ודוגמיות",
      externalOrderTypes: "סוגי הזמנות ללקוחות חיצוניים",
      internalOrderTypes: "סוגי הזמנות ללקוחות פנימיים",
      contactCodes: "קודי התקשרות",
      code: "קוד",
      description: "תיאור",
      save: "שמור",
      cancel: "בטל",
      addRow: "הוסף שורה",
      placeholder: "+"
  };
  
  export default translations;
  